(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.controller:UsuarisCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols')
    .controller('RolsCtrl', RolsCtrl);

  function RolsCtrl() {
    var vm = this;
    vm.ctrlName = 'RolsCtrl';
  }
}());
